import { useEffect, useState } from "react";
import { db } from "../../firebase";

import {
  collection,
  getDocs,
  query,
  where,
  orderBy
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import moment from "moment";

import VendorAssignmentModal from "../../components/purchase/VendorAssignmentModal";

export default function PurchaseList() {

  const [data, setData] = useState([]);

  const [unitMap, setUnitMap] = useState({});

  const navigate = useNavigate();

  const [
    showVendorModal,
    setShowVendorModal
  ] = useState(false);

  const [
    selectedPurchase,
    setSelectedPurchase
  ] = useState(null);

  const [
    expandedBatch,
    setExpandedBatch
  ] = useState(null);

  useEffect(() => {

    fetchData();

    fetchUnits();

  }, []);

  // ============================================
  // FETCH PURCHASE REQUESTS
  // ============================================

  const fetchData = async () => {

    try {

      const user      = JSON.parse(localStorage.getItem("user") || "{}");
const companyId = user.company_id || "";

const q = query(
  collection(db, "purchase_requests"),
  where("company_id", "==", companyId),
  orderBy("created_at", "desc")
);

      const snap =
        await getDocs(q);

      const list =
        snap.docs.map((docSnap) => {

          const d =
            docSnap.data();

          const map = {};

          (d.items || []).forEach(
            (item) => {

              const itemId =
                String(
                  item.item_id || ""
                ).trim();

              const siteId =
                String(
                  item.site_id ||
                  ""
                ).trim();

              const key =
                `${itemId}_${siteId}`;

              if (!itemId) return;

              if (map[key]) {

                map[key].qty +=
                  Number(
                    item.qty || 0
                  );

              } else {

                map[key] = {

                  ...item,

                  qty: Number(
                    item.qty || 0
                  ),

                  site_id:
                    siteId
                };
              }
            }
          );

          return {

            id:
              docSnap.id,

            ...d,

            items:
              Object.values(map)
          };
        });

      setData(list);

    } catch (error) {

      console.error(
        "PURCHASE LIST ERROR:",
        error
      );
    }
  };

  // ============================================
  // FETCH UNITS
  // ============================================

  const fetchUnits = async () => {
    try {
      const user      = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = user.company_id || "";
      const snap = await getDocs(
        query(collection(db, "material_requests"),
        where("company_id", "==", companyId))
      );

      const map = {};

      snap.forEach((docSnap) => {

        const mrf =
          docSnap.data();

        (mrf.items || []).forEach(
          (item) => {

            const name =
              item.item_name?.toLowerCase();

            if (!name) return;

            if (
              item.unit &&
              item.unit !== "nos"
            ) {

              map[name] =
                item.unit;
            }
          }
        );
      });

      setUnitMap(map);

    } catch (error) {

      console.error(
        "UNIT FETCH ERROR:",
        error
      );
    }
  };

  // ============================================
  // UNIT FIX
  // ============================================

  const getUnit = (item) => {

    const name =
      item.item_name?.toLowerCase();

    if (unitMap[name]) {
      return unitMap[name];
    }

    const raw =

      item.unit ||

      item.uom ||

      item.units ||

      item.unit_name ||

      "";

    if (!raw) {
      return "nos";
    }

    const u =
      raw.toLowerCase();

    if (
      ["meter", "mtr", "m"].includes(u)
    ) {

      return "meter";
    }

    if (
      ["kg", "kgs"].includes(u)
    ) {

      return "kg";
    }

    if (
      ["nos", "no", "number"].includes(u)
    ) {

      return "nos";
    }

    return raw;
  };

  // ============================================
  // TOGGLE EXPAND
  // ============================================

  const toggleBatch = (
    batchId
  ) => {

    setExpandedBatch(

      expandedBatch === batchId

        ? null

        : batchId
    );
  };

  // ============================================
  // OPEN VENDOR MODAL
  // ============================================

  const openVendorModal = (
    purchase
  ) => {

    setSelectedPurchase(
      purchase
    );

    setShowVendorModal(
      true
    );
  };

  // ============================================
  // UI
  // ============================================

  return (

    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-6">

      <div className="max-w-7xl mx-auto">

        {/* HEADER */}

        <div className="flex items-center justify-between mb-10">

          <div>

            <h1 className="text-4xl font-black tracking-tight text-slate-900">
              Purchase Requests
            </h1>

            <p className="text-slate-500 mt-2 text-sm">
              Procurement batches, vendor dispatch and GRN workflow.
            </p>

          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/purchase-orders")}
              className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white text-sm font-semibold rounded-xl hover:bg-indigo-700 transition shadow-sm"
            >
              📋 Purchase Orders →
            </button>

            <div className="bg-white border border-slate-200 shadow-sm rounded-3xl px-8 py-5 min-w-[180px]">
              <div className="text-xs uppercase tracking-widest text-slate-400 font-bold">
                Active Requests
              </div>
              <div className="text-4xl font-black text-slate-800 mt-1">
                {data.length}
              </div>
            </div>
          </div>

        </div>

        {/* LIST */}

        {data.map((p) => (

          <div
            key={p.id}
            className="bg-white/90 backdrop-blur-sm rounded-3xl border border-slate-200/70 shadow-[0_10px_40px_rgba(15,23,42,0.06)] hover:shadow-[0_20px_60px_rgba(15,23,42,0.12)] transition-all duration-300 mb-4 overflow-hidden"
          >

            {/* HEADER */}

            <div

              onClick={() =>
                toggleBatch(p.id)
              }

              className="flex justify-between items-center px-5 py-4 border-b bg-gradient-to-r from-slate-50 to-white cursor-pointer hover:bg-slate-50 transition"
            >

              {/* LEFT */}

              <div>

                <div className="text-lg font-bold text-slate-800">

                  {
                    p.purchase_request_no ||

                    "Purchase Request"
                  }

                </div>

                {/* DATE */}

                <div className="mt-1 text-sm text-gray-500">

                  Created:

                  {" "}

                  {
                    p.created_at?.toDate

                      ? moment(
                          p.created_at.toDate()
                        ).format(
                          "DD MMM YYYY • hh:mm A"
                        )

                      : "--"
                  }

                </div>

                {/* CREATED BY */}

                <div className="text-xs text-gray-400 mt-1">

                  Created By:

                  {" "}

                  {
                    p.created_by_name ||

                    "System"
                  }

                </div>

                {/* ANALYTICS */}

                <div className="flex flex-wrap items-center gap-2 mt-3">

                  <span className="text-[11px] font-bold px-3 py-1 rounded-full bg-slate-100 text-slate-700">

                    {
  p.items?.filter(
    (item) => !item.deleted
  ).length || 0
}

                    {" "}
                    Items

                  </span>

                  <span className="text-[11px] font-bold px-3 py-1 rounded-full bg-cyan-100 text-cyan-700">

                    {
                      p.total_sites || 0
                    }

                    {" "}
                    Sites

                  </span>

                  <span className="text-[11px] font-bold px-3 py-1 rounded-full bg-violet-100 text-violet-700">

                    {
                      p.total_mrfs || 0
                    }

                    {" "}
                    MRFs

                  </span>

                  <span className="text-[11px] text-cyan-600 font-semibold cursor-pointer">

                    {
                      expandedBatch === p.id

                        ? "Collapse"

                        : "Expand"
                    }

                  </span>

                </div>

              </div>

              {/* RIGHT */}

              <div className="flex items-center gap-3">

                {/* ========================================= */}
{/* PROCUREMENT ACTIONS */}
{/* ========================================= */}

{
  (
  !p.procurement_status ||

  p.procurement_status ===
"pending_vendor"
) && !p.vendor_id && (

    <button

      onClick={(e) => {

        e.stopPropagation();

        openVendorModal(p);
      }}

      className="bg-gradient-to-r from-indigo-600 to-cyan-500 text-white text-xs px-4 py-2 rounded-xl shadow-md hover:scale-[1.02] transition"
    >

      Assign Vendor

    </button>
  )
}

{
  (
    p.procurement_status === "vendor_assigned" ||
    (
      p.vendor_id &&
      (
        !p.procurement_status ||
        p.procurement_status === "pending_vendor"
      )
    )
  ) && (

    <button

      onClick={(e) => {

        e.stopPropagation();

        openVendorModal(p);
      }}

      className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-xs px-4 py-2 rounded-xl shadow-md hover:scale-[1.02] transition"
    >

      Generate PO

    </button>
  )
}

{
  p.procurement_status ===
    "po_generated" && (

    <button

      onClick={(e) => {

        e.stopPropagation();

        navigate(
          `/purchase-orders/${p.po_id}`
        );
      }}

      className="bg-gradient-to-r from-violet-600 to-indigo-500 text-white text-xs px-4 py-2 rounded-xl shadow-md"
    >

      View PO

    </button>
  )
}

{
  [
    "sent_to_vendor",
    "partial_delivery",
    "grn_complete"
  ].includes(
    p.procurement_status
  ) && (

    <button

      onClick={(e) => {

        e.stopPropagation();

        navigate(
          `/receive/${p.id}`
        );
      }}

      className="bg-gradient-to-r from-emerald-600 to-teal-500 text-white text-xs px-4 py-2 rounded-xl shadow-md"
    >

      GRN

    </button>
  )
}

                {/* STATUS */}

                <span
  className={`text-xs font-bold px-4 py-2 rounded-full border ${
    (
      (
  !p.procurement_status ||

  p.procurement_status ===
"pending_vendor"
)
    )
      ? "bg-amber-100 text-amber-700 border-amber-200"

      : p.procurement_status ===
        "vendor_assigned"
      ? "bg-cyan-100 text-cyan-700 border-cyan-200"

      : p.procurement_status ===
  "po_generated"
? "bg-violet-100 text-violet-700 border-violet-200"

      : p.procurement_status ===
        "sent_to_vendor"
      ? "bg-blue-100 text-blue-700 border-blue-200"

      : p.procurement_status ===
        "partial_delivery"
      ? "bg-orange-100 text-orange-700 border-orange-200"

      : p.procurement_status ===
        "grn_complete"
      ? "bg-emerald-100 text-emerald-700 border-emerald-200"

      : p.procurement_status ===
        "closed"
      ? "bg-slate-200 text-slate-700 border-slate-300"

      : "bg-gray-200 text-gray-600 border-gray-300"
  }`}
>

  {
    (
  !p.procurement_status ||

  p.procurement_status ===
"pending_vendor"
)
  ? "Pending Vendor Assignment"

      : p.procurement_status ===
        "vendor_assigned"
      ? "Vendor Assigned"

      : p.procurement_status ===
  "po_generated"
      ? "PO Generated"

      : p.procurement_status ===
        "sent_to_vendor"
      ? "Sent To Vendor"

      : p.procurement_status ===
        "partial_delivery"
      ? "Partial Delivery"

      : p.procurement_status ===
        "grn_complete"
      ? "GRN Complete"

      : p.procurement_status ===
        "closed"
      ? "Closed"

      : p.procurement_status
  }

</span>

              </div>

            </div>

            {/* EXPANDED ITEMS */}

            {
              expandedBatch === p.id && (

                <div className="divide-y">

                  {
                    p.items?.map(
                      (item, i) => {

                        const unit =
                          getUnit(item);

                        return (

                          <div
                            key={`${item.item_id}_${item.site_id}_${i}`}
                            className="flex justify-between items-center px-6 py-3 hover:bg-slate-50/70 transition"
                          >

                            <div>

                              <div className="text-sm font-semibold text-slate-700">
                                {item.item_name}
                              </div>

                              <div className="text-xs text-gray-400">

                                {
                                  unit !== "nos"

                                    ? unit

                                    : ""
                                }

                              </div>

                            </div>

                            <div className="text-sm font-semibold">

                              {item.qty} {unit}

                            </div>

                          </div>
                        );
                      }
                    )
                  }

                </div>
              )
            }

          </div>
        ))}

        {
          data.length === 0 && (

            <div className="text-center py-10 text-gray-400">

              No purchase requests found

            </div>
          )
        }

      </div>

      {/* MODAL */}

      <VendorAssignmentModal

        open={showVendorModal}

        onClose={() => {

  setShowVendorModal(false);

  setSelectedPurchase(null);

  fetchData();
}}

        purchaseRequest={selectedPurchase}

      />

    </div>
  );
}